import { BodyZone, MuscleTag } from '@/generated';

export const muscleTagFilter = (allMuscleTags: Array<MuscleTag>, filterName: string, selectedBodyZone: BodyZone, compound?: boolean) => {
  let filtered = allMuscleTags;

  if (filterName !== '') {
    filtered = allMuscleTags?.filter((mt) => mt.name.toLowerCase().includes(filterName.toLowerCase()));
  }

  if (selectedBodyZone.id !== 'nz')
    filtered = filtered.filter((f) => selectedBodyZone.zoneTagIds.includes(f.id) || selectedBodyZone.zoneTagIds.some((ztid) => f.groupMuscleTagIds?.some((id) => id === ztid)));

  if (compound === true) {
    filtered = filtered.filter((f) => f.groupMuscleTagIds?.length);
  } else if (compound === false) {
    filtered = filtered.filter((f) => !f.groupMuscleTagIds?.length);
  }

  return filtered;
};
